import React from 'react';
import PropTypes from 'prop-types';
import { BellFilled } from '@ant-design/icons';
import { Button, Row, Col, Popconfirm, message, Tooltip, Radio, Icon } from 'antd';
import { IconContactEmpty as IconContactEmptyIcon } from 'common/components/svgs';
import LandlordContactModal from '~pages/dashboard/landlord/contact-modal';
import * as queries from '~settings/queries';
import { fetch } from '~helpers/graphql';
import { landlordContactType, landlordLinkManEnum } from '~constants/landlord';
import queryString from 'query-string';

export default class LandlordContact extends React.PureComponent {
  constructor(props) {
    super(props);

    const search = queryString.parse(location?.search);

    this.state = {
      isShowAddContactModal: false,
      isEmptyPage: true,
      modalType: 'create',
      currentLandlordContact: null,
      currentContactType: search?.contactType || landlordContactType.LANDLORD,
    };
  }

  handleClickAddContact = (item, type) => {
    if (type) {
      this.setState({ modalType: type });
    }
    this.setState({
      isShowAddContactModal: !this.state.isShowAddContactModal,
      currentLandlordContact: item,
    });
  };

  updateLandlordContact = (type, object) => {
    const { landlord, setCurrentLandlord, t } = this.props;
    const { currentContactType } = this.state;
    const currentContactTypeLowercase = landlordLinkManEnum[currentContactType];
    const linkMenArray = landlord?.landlordLinkMen[landlordLinkManEnum[currentContactType]];

    if (type === 'create') {
      linkMenArray.unshift(object);

      setCurrentLandlord({
        ...landlord,
        landlordLinkMen: {
          ...landlord.landlordLinkMen,
          [currentContactTypeLowercase]: linkMenArray,
        },
      });
      message.success(t('cms.landlord.contact.add_new_contact.success.toast'));
    } else if (type === 'edit') {
      const editIndex = linkMenArray.findIndex(item => item.id === object.id);
      linkMenArray.splice(editIndex, 1, object);

      setCurrentLandlord({
        ...landlord,
        landlordLinkMen: {
          ...landlord.landlordLinkMen,
          [currentContactTypeLowercase]: linkMenArray,
        },
      });
      message.success(t('cms.landlord.contact.edit_contact.success.toast'));
    } else if (type === 'delete') {
      fetch(queries.deleteLandlordLinkMan({ id: object.id })).then(response => {
        if (response?.deleteLandlordLinkMan?.landlordLinkMan) {
          const editIndex = linkMenArray.findIndex(item => item.id === object.id);
          linkMenArray.splice(editIndex, 1);

          setCurrentLandlord({
            ...landlord,
            landlordLinkMen: {
              ...landlord.landlordLinkMen,
              [currentContactTypeLowercase]: linkMenArray,
            },
          });
          message.success(t('cms.landlord.contact.delete_contact.success.toast'));
        }
      });
    }
  };

  render() {
    const { t, landlord } = this.props;
    const { modalType, currentLandlordContact, currentContactType } = this.state;

    const { landlordLinkMen = { bookingTeam: [], landlord: [], property: [], financeTeam: [] } } =
      landlord ?? {};

    const currentContacts = landlordLinkMen[landlordLinkManEnum[currentContactType]];

    return (
      <div className="landlord-contact">
        <div className="landlord-contact__content-wrap">
          <div className="landlord-contact__menu-bar">
            <Radio.Group
              onChange={e => {
                this.setState({
                  currentContactType: e.target.value,
                });
              }}
              value={currentContactType}
            >
              <Tooltip title={t('cms.landlord.contact.select.landlord.tooltip')}>
                <Radio.Button value={landlordContactType.LANDLORD}>
                  {t('cms.landlord.contact.select.landlord.label')}
                </Radio.Button>
              </Tooltip>
              <Tooltip title={t('cms.landlord.contact.select.landlord.tooltip')}>
                <Radio.Button value={landlordContactType.PROPERTY}>
                  {t('cms.landlord.contact.select.property.label')}
                </Radio.Button>
              </Tooltip>
              <Tooltip title={t('cms.landlord.contact.select.booking_team.tooltip')}>
                <Radio.Button value={landlordContactType.BOOKING_TEAM}>
                  {t('cms.landlord.contact.select.booking_team.label')}
                </Radio.Button>
              </Tooltip>
              <Tooltip title={t('cms.landlord.contact.select.finance_team.tooltip')}>
                <Radio.Button value={landlordContactType.FINANCE_TEAM}>
                  {t('cms.landlord.contact.select.finance_team.label')}
                </Radio.Button>
              </Tooltip>
            </Radio.Group>

            {!!currentContacts.length && (
              <div className="landlord-contact__content-page__plus-container">
                <Button
                  icon="plus"
                  onClick={() => {
                    this.handleClickAddContact({}, 'create');
                  }}
                  block
                  // type="default"
                >
                  {t(
                    `cms.landlord.contact.add_new_${currentContactType.toLowerCase()}_contact.btn`,
                  )}
                </Button>
              </div>
            )}
          </div>

          {/* empty page */}
          <If condition={currentContacts.length === 0}>
            <div className="landlord-contact__empty-page-wrap">
              <div className="landlord-contact__empty-page">
                <IconContactEmptyIcon className="landlord-contact__empty-page__icon" />
                <span className="landlord-contact__empty-page__content">
                  {t('cms.landlord.contact.add_new_contact.description')}
                </span>
                <div className="landlord-contact__empty-page__add">
                  <Button
                    icon="plus"
                    type="primary"
                    size="large"
                    onClick={() => {
                      this.handleClickAddContact({}, 'create');
                    }}
                  >
                    {t(
                      `cms.landlord.contact.add_new_${currentContactType.toLowerCase()}_contact.btn`,
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </If>

          <If condition={currentContacts.length > 0}>
            <div className="landlord-contact__content-page">
              <h3>{t('cms.landlord.contact.contact_level.landlord.label')}</h3>
              <For of={currentContacts} each="landlordLinkMenItem" index="index">
                <section className="landlord-contact__section" key={landlordLinkMenItem.id}>
                  <div className="landlord-contact__header-container">
                    <div className="landlord-contact__title-wrapper">
                      <Icon type="contacts" width={16} height={16} style={{ marginRight: 12 }} />
                      <p className="landlord-contact__title">{`${t(
                        `cms.landlord.contact.select.${currentContactType.toLowerCase()}.label`,
                      )} ${index + 1}`}</p>

                      <If condition={landlordLinkMenItem.isBillingNotificationEmail}>
                        <Tooltip
                          title={t('cms.landlord.contact.billing_notification_email_notice')}
                        >
                          <BellFilled />
                        </Tooltip>
                      </If>
                    </div>

                    <If condition={!landlordLinkMenItem?.landlordContactId}>
                      <span className="landlord-contact__header-container__btn-container">
                        <button
                          className="landlord-contact__header-container__icon-wrap"
                          onClick={() => this.handleClickAddContact(landlordLinkMenItem, 'edit')}
                        >
                          {t('cms.landlord.detail.edit.button')}
                        </button>
                        <span className="landlord-contact__header-container__line" />
                        <Popconfirm
                          overlayClassName="property-detail-wrapper__popconfirm"
                          overlayStyle={{ maxWidth: 210 }}
                          arrowPointAtCenter
                          placement="topRight"
                          title={t('cms.landlord.contact.double_confirm.title')}
                          onConfirm={() =>
                            this.updateLandlordContact('delete', landlordLinkMenItem)
                          }
                          okText={t('cms.properties.edit.btn.yes')}
                          okType="danger"
                          cancelText={t('cms.properties.edit.btn.no')}
                        >
                          <button
                            className="landlord-contact__header-container__icon-wrap landlord-contact__header-container__delete"
                            onClick={() => {}}
                          >
                            {t('cms.landlord.modal.button.delete')}
                          </button>
                        </Popconfirm>
                      </span>
                    </If>
                  </div>
                  <div className="landlord-contact__section-content">
                    <Row gutter={16}>
                      <Col span={12} className="landlord-contact__section-content__label">
                        <label>{t('cms.landlord.contact.contact_name.label')}: </label>
                        {landlordLinkMenItem.contactName || '-'}
                      </Col>
                      <Col span={12} className="landlord-contact__section-content__label">
                        <label>{t('cms.landlord.contact.contact_email.label')}: </label>
                        {landlordLinkMenItem.contactEmail || '-'}
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={12} className="landlord-contact__section-content__label">
                        <label>{t('cms.landlord.contact.contact_phone.label')}: </label>
                        {landlordLinkMenItem.contactPhone || '-'}
                      </Col>
                      <Col span={12} className="landlord-contact__section-content__label">
                        <label>{t('cms.landlord.contact.contact_occupation.label')}: </label>
                        {landlordLinkMenItem.occupation || '-'}
                      </Col>
                    </Row>
                  </div>
                </section>
              </For>
            </div>
          </If>
        </div>

        <If condition={this.state.isShowAddContactModal}>
          <LandlordContactModal
            activeModal
            t={t}
            type={modalType}
            contactType={currentContactType}
            landlord={landlord}
            handleCloseModal={this.handleClickAddContact}
            currentLandlordContact={currentLandlordContact}
            handleUpdateLandlordContact={this.updateLandlordContact}
            updateLandlord={this.props.updateLandlord}
          />
        </If>
      </div>
    );
  }
}

LandlordContact.propTypes = {
  t: PropTypes.func.isRequired,
  landlord: PropTypes.object,
  updateLandlord: PropTypes.func,
  setCurrentLandlord: PropTypes.func,
};

LandlordContact.defaultProps = {
  t: () => {},
  landlord: {},
  updateLandlord: () => {},
  setCurrentLandlord: () => {},
};
